import styled from 'styled-components';

export const TextStyled = styled(`p`)`
	color: #77818e;
	white-space: pre-wrap;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
`;
